<template>
  <YdDialog :visible="visibleLook" append-to-body @close="closeLook" width="450px">
    <div
      class=""
      style="width: 375px; min-height: 1080px; padding-bottom: 35px; position: relative"
      :style="{
        backgroundColor: activityInfo.type !== 4 ? activityInfo.backgroundColor : '#feeec7'
      }"
    >
      <div class="banner">
        <img
          :src="
            activityInfo.type === 4
              ? 'https://qiniu-sys.ayundi.cn/img/user/new-year.png'
              : activityInfo.images
          "
          class="full-width"
        />
      </div>

      <div class="record"> 抽奖记录</div>

      <div class="pool position-relative">
        <img src="@/static/prize-draw/pool.png" class="full-width bg" />

        <div class="list" style="padding: 27px 38px 0 38px">
          <div
            class="item position-absolute overflow-hide"
            :class="'item' + index"
            v-for="(item, index) in activityInfo.prizes"
            :key="item.id"
          >
            <img src="@/static/prize-draw/item-bg.png" style="width: 95px" />
            <div class="text position-absolute">
              <img
                :src="
                  item.type === 4
                    ? 'https://qiniu-sys.ayundi.cn/img_v3_02ih_10dea323-4a95-4f7c-82b3-4a03df52057g.png'
                    : item.prizeImage
                "
                style="width: 38px; height: 38px; margin-top: 12px"
              />
              <div
                class="font-12 flex flex-align-center flex-justify-center"
                style="color: #903000; width: 60px; height: 35px"
              >
                <span>{{ item.prizeName }}</span>
              </div>
            </div>
            <div v-if="index !== current" class="mask position-absolute"></div>
          </div>

          <div class="start-btn position-absolute">
            <img src="@/static/prize-draw/btn-bg.png" style="width: 95px" />
            <div class="text color-fff position-absolute">
              <div class="font-weight font-32" style="line-height: 48px">抽奖</div>
              <div class="font-16" style="line-height: 24px"
                >剩余{{ activityInfo.remainCount > 0 ? activityInfo.remainCount : 0 }}次</div
              >
            </div>
          </div>
        </div>
      </div>

      <div class="padding-x-10 rule">
        <img src="@/static/prize-draw/rule-icon.png" class="full-width" />
        <div class="rule-text font-14 color-333 padding-x-20 color-bg-fff">
          <div class="" v-html="activityInfo.description"></div>
        </div>
      </div>

      <div class="padding-x-10 namelist" v-if="activityInfo.fakeWinnerListToggle === 1">
        <img src="@/static/prize-draw/namelist-icon.png" class="full-width" />
        <div class="name-list padding-x-40">
          <template v-if="activityInfo.winnerList.length">
            <div
              class="borders list font-14 flex flex-justify-between flex-align-center"
              v-for="(item, index) in activityInfo.winnerList"
              :key="index"
            >
              <div class="color-333">{{ item.userPhone }}</div>
              <div class="" style="color: #d14e07">{{ item.rewardName }}</div>
            </div>
          </template>
          <div
            v-else
            class="flex flex-justify-center flex-align-center padding-top-30"
            style="min-height: 200px"
          >
            暂无内容
          </div>
        </div>
      </div>

      <!-- <div class="go flex flex-align-center flex-justify-center">
        <button
          style="height: 50px;width: 343px;background: linear-gradient(90deg,#fa8e15 0%, #f89718 48%, #fc6500 100%)"
          shape="circle"
          color="#FFFFFF"
        >
          <span>乘车参与抽奖</span>
        </button>
      </div> -->
    </div>
  </YdDialog>
</template>

<script>
  import { preview, winnerList } from '@/api/marketing/prize-draw'
  import _ from 'lodash-es'
  export default {
    data() {
      return {
        activityInfo: {}, // 活动信息
        receiveShow: false,
        resultShow: false,
        resultType: false,
        timer: null,
        current: 0, // 当前下标
        interNum: 0,
        interCount: 0, // 遍历次数
        winnerList: [],
        maxCount: 16,
        winnersData: {}, // 抽奖信息
        winnersRes: {},
        prizeFlag: true, // 抽奖状态
        winnertListCurrent: 1
      }
    },
    props: {
      visibleLook: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      closeLook() {
        this.activityInfo = {}
        this.$emit('closeLook')
      },
      // 中奖名单
      async getWinnerListFun(id) {
        const data = {
          current: 1,
          raffleActivityId: id,
          size: 5
        }
        const res = await winnerList(data)
        if (res.code === 0) {
          this.winnerList = res.data.records
          if (this.winnertListCurrent < res.data.pages - 1) {
            this.winnertListCurrent++
          } else {
            this.winnertListCurrent = 1
          }
        }
      },
      // 获取活动详情
      async init(id) {
        const res = await preview(id)
        res.prizes = _.orderBy(res.prizes, ['sort'], ['desc'])
        this.activityInfo = res.data
        // this.getWinnerListFun(id)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .full-width {
    width: 100%;
  }
  .record {
    position: absolute;
    right: 0;
    top: 132px;
    z-index: 99;
    background: rgba(0, 0, 0, 0.4);
    width: 68px;
    height: 26px;
    text-align: center;
    line-height: 26px;
    border-radius: 25px 0 0 25px;
    color: #fff;
    font-size: 12px;
  }

  .pool {
    transform: translateY(-43px);
    height: 415px;
    .bg {
      position: absolute;
    }

    .item {
      width: 95px;
      height: 95px;
      background: rgba(0, 0, 0, 0.4);
      border-radius: 14px;
      .text {
        text-align: center;
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
      }
    }
    .item0 {
      left: 38px;
      top: 27px;
    }
    .item1 {
      left: 140px;
      top: 27px;
    }
    .item2 {
      right: 38px;
      top: 27px;
    }
    .item3 {
      right: 38px;
      top: 129px;
    }
    .item4 {
      right: 38px;
      top: 231px;
    }
    .item5 {
      left: 140px;
      top: 231px;
    }
    .item6 {
      left: 38px;
      top: 231px;
    }
    .item7 {
      left: 38px;
      top: 129px;
    }

    .start-btn {
      left: 140px;
      top: 129px;

      .text {
        top: 0;
        left: 0;
        padding: 10px 10px;
        box-sizing: border-box;
        text-align: center;
        width: 100%;
      }
    }
    .mask {
      width: 95px;
      height: 95px;
      top: 0;
      left: 0;
    }
  }

  .rule {
    .rule-text {
      min-height: 50px;
      max-height: 315px;
      padding-bottom: 24px;
      transform: translateY(-40px);
      background: linear-gradient(180deg, #fffbf3 0%, #ffffff 100%);
      border-radius: 20px;
      overflow: hidden;
      overflow-y: scroll;
      scrollbar-width: none; /* firefox */
      -ms-overflow-style: none; /* IE 10+ */
      overflow-x: hidden;
      overflow-y: auto;
    }
  }
  .name-list {
    overflow: hidden;
    overflow-y: scroll;
    scrollbar-width: none; /* firefox */
    -ms-overflow-style: none; /* IE 10+ */
    overflow-x: hidden;
    overflow-y: auto;
    min-height: 200px;
    transform: translateY(-40px);
    border-radius: 20px;
    background: linear-gradient(180deg, #fffbf3 0%, #ffffff 100%);
    .list {
      width: 275px;
      height: 41px;
    }
    .borders {
      border-bottom: 1px solid;
      border-image: linear-gradient(
          90deg,
          rgba(255, 199, 98, 0.3),
          #d14e07 51%,
          rgba(255, 199, 98, 0.3) 100%
        )
        1 1;
    }
  }

  // .go {
  //   position: absolute;
  //   bottom: 0;
  //   left: 0;
  //   z-index: 99;
  //   height: 63px;
  //   width: 100%;
  //   background-color: #fff;
  // }

  .closeIcon {
    transform: translateY(72px);
  }
  .rule-text::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
  .name-list::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
</style>
